import Link from 'next/link';
import { FC, useMemo } from 'react';
import { Body, Title } from 'atoms/Typography/Typography';
import { Price, PriceItem } from 'molecules/Tooltip/types';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useSiteConfig } from 'modules/shop/siteConfig/hooks';
import styles from './styles.module.css';

export const ShippingInfo: FC = () => {
  const t = useTranslations();
  const { shipping } = useSiteConfig();

  const prices = useMemo(
    () =>
      shipping?.prices?.tbody?.map((price: PriceItem) => {
        return {
          from: price?.body?.[0]?.value || '0',
          to: price?.body?.[1]?.value || '0',
        };
      }),
    [shipping],
  );

  return !shipping || !prices?.length ? null : (
    <>
      <Title type="md" className={styles.title}>
        {t('product.shipping.title')}
      </Title>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>
              <Body tag="span" type="md" weight="medium">
                {t('product.shipping.orderValue')}
              </Body>
            </th>
            <th>
              <Body tag="span" type="md" weight="medium">
                {t('product.shipping.shippingCosts')}
              </Body>
            </th>
          </tr>
        </thead>
        <tbody>
          {prices.map((price: Price, idx: number) => {
            return (
              <tr key={idx}>
                <td>
                  <Body tag="span" type="md" weight="medium">
                    {idx === 0
                      ? t('product.shipping.to')
                      : t('product.shipping.from')}{' '}
                    € {price.from}
                  </Body>
                </td>
                <td className={styles.shippingCosts}>
                  <Body tag="span" type="md" weight="medium">
                    {idx === prices.length - 1
                      ? t('product.shipping.free')
                      : `${t('product.shipping.only')} € ${price.to}`}
                  </Body>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <Link className={styles.infoLink} href={`/${shipping.infoLink}`}>
        <Body tag="span" type="md" weight="medium">
          {t('product.shipping.moreInfo')}
        </Body>
      </Link>
    </>
  );
};
